// the only way to adjust the xs size is to define all size values.
// Otherwise, defining one resets all of them 😭
export const boxSizes = {
  xs: {
    boxSize: 2.5,
    fontSize: 5,
    lineHeight: 2.5,
    paddingHorizontalDense: 0.5,
    paddingHorizontal: "6px",
    paddingVertical: 0,
    radius: 2.5
  },
  sm: {
    boxSize: 3,
    fontSize: 4,
    lineHeight: 3,
    paddingHorizontalDense: 0.5,
    paddingHorizontal: 1,
    paddingVertical: 0,
    radius: 3
  },
  md: {
    boxSize: 4,
    fontSize: 3,
    lineHeight: 4,
    paddingHorizontalDense: 1,
    paddingHorizontal: "12px",
    paddingVertical: 0,
    radius: 4
  },
  lg: {
    boxSize: 5,
    fontSize: 3,
    lineHeight: 5,
    paddingHorizontalDense: 1,
    paddingHorizontal: "14px",
    paddingVertical: 0,
    radius: 5
  },
  xl: {
    boxSize: 6,
    fontSize: 3,
    lineHeight: 6,
    paddingHorizontalDense: 2,
    paddingHorizontal: "18px",
    paddingVertical: 0,
    radius: 6
  }
}
